/**
 * Gets the logged in user data from local storage
 */
export function getLoggedInUser() {
    const authUser = localStorage.getItem('authUser');
    return authUser ? JSON.parse(authUser) : null;
}

export function isUserAuthenticated() {
    return getLoggedInUser() !== null;
}
